import { gql } from '@apollo/client';

export const ALL_OUTCOMES_INDICATORS_BY_INTERVENTION = gql`
  query AllOutcomeIndicatorsByIntervention($interventionId: ID!, $outcomeId: ID!) {
    indicators: allOutcomeIndicatorsByIntervention(interventionId: $interventionId, outcomeId: $outcomeId) {
      id
      type
      unit
      measurementUnit
      startDate
      endDate
      numberOfDataEntries
      name
    }
  }
`;
